/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Storage_No_SpacesInputs */



/**
* | output |
* | --- |
* | "No active storage spaces found" |
*
* @param {Dashboard_Storage_No_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_no_spaces = /** @type {((inputs?: Dashboard_Storage_No_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_No_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine aktiven Speicherbereiche gefunden")
	return /** @type {LocalizedString} */ ("No active storage spaces found")
});